// Fork from legacy-packages/business-customization/shared-customization-ui/src/components/Toast/index.tsx

import * as React from 'react';

import { IconToastExclamation36, IconToastSuccessful36 } from '@nebula/icon';

import type { ToastProps } from './types';

import styles from './style.scss';

const ICON_MAPPING = {
  success: IconToastSuccessful36,
  warning: IconToastExclamation36,
};

export default function Toast({ text, level }: ToastProps) {
  const Icon = ICON_MAPPING[level];
  return (
    <div className={styles.toastBox}>
      <Icon className={styles.icon} />
      <p className={styles.text}>{text}</p>
    </div>
  );
}
